import { FormFieldComponentProps } from './fieldProps';

const VideoField = ({ field }: FormFieldComponentProps) => {
	const videoUrl = field.settings.video as string | undefined;

	if (!videoUrl) {
		return field.label ? <div className='biz-form-field__label'>{field.label}</div> : null;
	}

	return (
		<>
			<div className='biz-form-field__video'>
				<video controls className='biz-form-field__video-player'>
					<source src={videoUrl} />
				</video>
			</div>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
		</>
	);
};

export default VideoField;
